import { PortalAuthConfig } from "./partner_config";
import { portalAuthPaths } from "./portal_paths";
import { withPartnerSlug } from "./portal_paths";

interface PortalAuth {
  development: PortalAuthConfig;
  staging: PortalAuthConfig;
  production: PortalAuthConfig;
}
export const portalAuth = (partnerSlug: string | undefined): PortalAuth => ({
  development: {
    domain: "flexspace-partners-portal-dev.us.auth0.com",
    audience: "https://api.flexspace-partners-portal-dev.ai",
    clientId: "jv7koW8B8g6t7SXot6nVwLjaza4IeZLb",
    redirectUri: `${window.location.origin}${withPartnerSlug(
      portalAuthPaths.callback,
      partnerSlug
    )}`,
  },
  staging: {
    domain: "portal-auth.partners-staging.flexspace.ai",
    clientId: "SIlGnPSJkPe6j4FYG2RL74Qzz5cTz3rZ",
    audience: "https://api.flexspace-partners-portal-staging.ai",
    redirectUri: `${window.location.origin}${withPartnerSlug(
      portalAuthPaths.callback,
      partnerSlug
    )}`,
  },
  production: {
    domain: "portal-auth.partners.flexspace.ai",
    clientId: "NkFtQP1lCuNaY4qb9NDKllet5Os3zBst",
    audience: "https://api.flexspace-partners-portal.ai",
    redirectUri: `${window.location.origin}${withPartnerSlug(
      portalAuthPaths.callback,
      partnerSlug
    )}`,
  },
});
